import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import FormSelect from "components/DigiHapi/FormSelect";
import PhoneMaskInput from "components/DigiHapi/PhoneMaskInput";

import {
	fetchGetAddressUsingZipCode,
	fetchGetCityUsingZipCode,
	fetchGetAddressUsingCoordinates
} from "actions/datagouv";

import {
	CLEAR_PHONE,
	CLEAR_EMAIL,
	CLEAR_WEB_SITE_URL,
	SET_GOODDEAL_ADDRESS,
	SET_GOODDEAL_CITY,
	SET_GOODDEALS_PHONE,
	SET_GOODDEALS_PHONE_ERROR,
	SET_GOODDEAL_EMAIL,
	SET_GOODDEALS_EMAIL_ERROR,
	SET_WEB_SITE_URL,
	SET_WEB_SITE_URL_ERROR,
	SET_GOODDEAL_ZIP_CODE,
	SET_GOODDEAL_SELECTED_CITY,
	SET_GOODDEAL_SELECTED_ADDRESS,
	SET_GOODDEAL_SELECTED_ZIPCODE,
	SET_FB_URL,
	CLEAR_FB_URL,
	SET_FB_URL_ERROR,
	SET_ZIPCODE_ERROR,
	SET_CITY_ERROR
} from "actions/types";

const OTHER = "Autre ...";

// Clear button displayed at the end of an input
const clearAdornment = onClick => (
	<InputAdornment position="end">
		<IconButton size="small" color="error" onClick={onClick}>
			<Icon fontSize="small">close</Icon>
		</IconButton>
	</InputAdornment>
);

// Select whose first item is "Autre ..." (custom value); onChange gets the selected label
const OtherSelect = ({ label, value, items, onSelect }) => (
	<FormSelect
		label={label}
		value={value}
		onChange={(e, child) => onSelect(child.props.children)}
	>
		<MenuItem>{OTHER}</MenuItem>
		{items.map(item => (
			<MenuItem key={item} value={item}>
				{item}
			</MenuItem>
		))}
	</FormSelect>
);

class Step4 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const {
			dispatch,
			phoneState,
			emailState,
			webSiteUrlState,
			fbUrlState,
			zipCode,
			city
		} = this.props;

		let success = true;
		if (phoneState === "error") {
			dispatch({
				type: SET_GOODDEALS_PHONE_ERROR
			});
			success = false;
		}
		if (emailState === "error") {
			dispatch({
				type: SET_GOODDEALS_EMAIL_ERROR
			});
			success = false;
		}
		if (webSiteUrlState === "error") {
			dispatch({
				type: SET_WEB_SITE_URL_ERROR
			});
			success = false;
		}
		if (fbUrlState === "error") {
			dispatch({
				type: SET_FB_URL_ERROR
			});
			success = false;
		}
		if (!zipCode) {
			dispatch({
				type: SET_ZIPCODE_ERROR
			});
			success = false;
		}
		if (!city) {
			dispatch({
				type: SET_CITY_ERROR
			});
			success = false;
		}
		return success;
	}

	render() {
		const {
			dispatch,
			phone,
			phoneState,
			phoneErrorMsg,
			customAddress,
			address,
			addresses,
			selectedAddress,
			addressUpdated,
			zipCodes,
			selectedZipCode,
			customZipCode,
			zipCode,
			zipCodeErrorMsg,
			zipCodeUpdated,
			cities,
			selectedCity,
			customCity,
			cityErrorMsg,
			webSiteUrl,
			webSiteUrlState,
			webSiteUrlErrorMsg,
			fbUrl,
			fbUrlState,
			fbUrlErrorMsg,
			email,
			emailState,
			emailErrorMsg,
			longitude,
			latitude
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					{selectedAddress === OTHER ? (
						<MDInput
							label="Adresse"
							id="address"
							fullWidth
							value={customAddress ? customAddress : ""}
							onChange={e =>
								dispatch({
									type: SET_GOODDEAL_ADDRESS,
									value: e.target.value
								})
							}
							onBlur={() => {
								if (addressUpdated && address) {
									if (zipCode) {
										this.props.fetchGetAddressUsingZipCode({
											address,
											zipCode
										});
									} else if (longitude && latitude) {
										this.props.fetchGetAddressUsingCoordinates({
											address,
											latitude,
											longitude
										});
									}
								}
							}}
						/>
					) : (
						<OtherSelect
							label="Adresse"
							value={selectedAddress}
							items={Object.keys(addresses)}
							onSelect={payload =>
								dispatch({
									type: SET_GOODDEAL_SELECTED_ADDRESS,
									payload
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					{selectedZipCode === OTHER ? (
						<MDInput
							label="Code postal *"
							id="zipcode"
							fullWidth
							error={!!zipCodeErrorMsg}
							helperText={zipCodeErrorMsg ? zipCodeErrorMsg : undefined}
							value={customZipCode ? customZipCode : ""}
							onChange={e =>
								dispatch({
									type: SET_GOODDEAL_ZIP_CODE,
									value: e.target.value
								})
							}
							onBlur={() =>
								zipCodeUpdated &&
								zipCode &&
								this.props.fetchGetCityUsingZipCode({ address, zipCode })
							}
						/>
					) : (
						<OtherSelect
							label="Code postal *"
							value={selectedZipCode}
							items={Object.keys(zipCodes)}
							onSelect={payload =>
								dispatch({
									type: SET_GOODDEAL_SELECTED_ZIPCODE,
									payload
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					{selectedCity === OTHER ? (
						<MDInput
							label="Ville *"
							id="city"
							fullWidth
							error={!!cityErrorMsg}
							helperText={cityErrorMsg ? cityErrorMsg : undefined}
							value={customCity ? customCity : ""}
							onChange={e =>
								dispatch({
									type: SET_GOODDEAL_CITY,
									value: e.target.value
								})
							}
						/>
					) : (
						<OtherSelect
							label="Ville *"
							value={selectedCity}
							items={Object.keys(cities)}
							onSelect={payload =>
								dispatch({
									type: SET_GOODDEAL_SELECTED_CITY,
									payload
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Téléphone"
						id="phone"
						fullWidth
						placeholder="+33 (0)X XX XX XX XX"
						success={!!phone && phoneState === "success"}
						error={phoneState === "error"}
						helperText={phoneErrorMsg ? phoneErrorMsg : undefined}
						value={phone ? phone : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEALS_PHONE,
								value: e.target.value
							})
						}
						InputProps={{
							inputComponent: PhoneMaskInput,
							endAdornment:
								phone !== null &&
								clearAdornment(() => dispatch({ type: CLEAR_PHONE }))
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Url site internet"
						id="url"
						fullWidth
						helperText={webSiteUrlErrorMsg ? webSiteUrlErrorMsg : undefined}
						success={!!webSiteUrl && webSiteUrlState === "success"}
						error={webSiteUrlState === "error"}
						value={webSiteUrl ? webSiteUrl : ""}
						onChange={e =>
							dispatch({
								type: SET_WEB_SITE_URL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								webSiteUrl !== null &&
								clearAdornment(() => dispatch({ type: CLEAR_WEB_SITE_URL }))
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Url page Facebook"
						id="fb-url"
						fullWidth
						helperText={fbUrlErrorMsg ? fbUrlErrorMsg : undefined}
						success={!!fbUrl && fbUrlState === "success"}
						error={fbUrlState === "error"}
						value={fbUrl ? fbUrl : ""}
						onChange={e =>
							dispatch({
								type: SET_FB_URL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								fbUrl !== null &&
								clearAdornment(() => dispatch({ type: CLEAR_FB_URL }))
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Email de contact"
						id="contact"
						fullWidth
						helperText={emailErrorMsg ? emailErrorMsg : undefined}
						success={!!email && emailState === "success"}
						error={emailState === "error"}
						value={email ? email : ""}
						onChange={e =>
							dispatch({
								type: SET_GOODDEAL_EMAIL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								email !== null &&
								clearAdornment(() => dispatch({ type: CLEAR_EMAIL }))
						}}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		addressUpdated,
		customAddress,
		addresses,
		selectedAddress,
		address,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCode,
		zipCodeErrorMsg,
		zipCodeUpdated,
		customCity,
		city,
		cityErrorMsg,
		selectedCity,
		cities,
		webSiteUrl,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		fbUrl,
		fbUrlState,
		fbUrlErrorMsg,
		latitude,
		longitude,
		phone,
		phoneErrorMsg,
		phoneState,
		email,
		emailState,
		emailErrorMsg
	} = state.gooddealReducer;
	return {
		address,
		customAddress,
		addresses,
		selectedAddress,
		addressUpdated,
		zipCode,
		zipCodeErrorMsg,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCodeUpdated,
		customCity,
		city,
		cityErrorMsg,
		selectedCity,
		cities,
		webSiteUrl,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		fbUrl,
		fbUrlState,
		fbUrlErrorMsg,
		latitude,
		longitude,
		phone,
		phoneErrorMsg,
		phoneState,
		email,
		emailState,
		emailErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetAddressUsingZipCode,
			fetchGetCityUsingZipCode,
			fetchGetAddressUsingCoordinates
		},
		dispatch
	);
	return { ...actions, dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step4);
